/**
 * F-155: a Short filled from the host's folders (Local Files) keeps where its
 * script came from. Its first two rows, in the Original Script column:
 *
 *   row 1 — the script's path, as plain text (edit it and the button follows);
 *   row 2 — `PLACE_VIDEO_CELL_TEXT`, which the grid draws as a *Place video*
 *           button: the host moves a video the user picks into the script's
 *           folder, renamed after the script (`PlaceVideoButton.tsx`).
 *
 * Both are ordinary cells — copied, exported, deleted like any other — so the
 * marker is the cell's text, and the button reads its path from the row above.
 * They ride on the import's own plan (`withScriptHeader`), so one Ctrl+Z or
 * Revert takes them back with the rows they head.
 */
import type { AgentOp, AgentPlan } from "@kola/shared";

/** The text a cell holds to be drawn as the *Place video* button. */
export const PLACE_VIDEO_CELL_TEXT = "▶ Place video";

export function isPlaceVideoCell(text: string): boolean {
  return text.trim() === PLACE_VIDEO_CELL_TEXT;
}

/** The two header rows, inserted above everything else. */
export function scriptHeaderOp(sourceColId: string, scriptPath: string): AgentOp {
  return {
    op: "insert_rows",
    index: 0,
    rows: [{ cells: { [sourceColId]: scriptPath } }, { cells: { [sourceColId]: PLACE_VIDEO_CELL_TEXT } }],
  };
}

/**
 * The import's plan with the header rows LAST — inserted at row 1 after the
 * file's rows have landed, so they head the sheet wherever the plan put those.
 */
export function withScriptHeader(plan: AgentPlan, sourceColId: string, scriptPath: string): AgentPlan {
  return { ...plan, ops: [...plan.ops, scriptHeaderOp(sourceColId, scriptPath)] };
}

/** The last segment of a host path, either separator. */
export function pathBaseName(path: string): string {
  const parts = path.split(/[\\/]/);
  return parts[parts.length - 1] || path;
}
